import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from 'axios';
import * as $ from 'jquery';
import Moment from 'moment';
import Select from 'react-select';
import 'bootstrap';
import Royal_logo from '../../Assets/images/Royal-logo.svg';
import html2pdf from 'html2pdf.js';
import moment from 'moment';
import Notice from '../../Assets/images/Roya-Resort-Notice.png';


// Utility functions
const getCurrentMonth = () => {
    const date = new Date();
    return date.getMonth();
};

const getMonthName = (monthIndex) => {
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return monthNames[monthIndex];
};

const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 4) {
        return digits;
    } else if (digits.length <= 11) {
        return `${digits.slice(0, 4)} ${digits.slice(4)}`;
    } else {
        return `${digits.slice(0, 4)} ${digits.slice(4, 11)}`;
    }
};

const ViewBooking = (props) => {
    const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
    const [filteredData, setFilteredData] = useState([]);
    const [items, setitems] = useState([]);
    const [itemsfilter, setitemsfilter] = useState([]);
    const [itemsnew, setitemsnew] = useState({ UnitId: "", bookby: "", bookingtype: "", MethodId: "", Mettype: "", ShiftId: "", AgentId: "", CustomerId: "", bookingdate: "", Amount: 0, company_id: "", note: "", Beforediscount: 0, type: "", userid: 0, receipt: "", Samount: 0, Damount: 0, per: "", trans: "", food: "", croc: "", Disnote: "", adv: 0, holdbook: "" });
    const [bookingdetails, setbookingdetails] = useState({});
    const [receviedamount, setreceviedamount] = useState({});
    const [isCheckedper, setIsCheckedper] = useState(false);
    const [isCheckedtrans, setIsCheckedtrans] = useState(false);
    const [isCheckedcroc, setIsCheckedcroc] = useState(false);
    const [isCheckedfood, setIsCheckedfood] = useState(false);
    const [customer, setcustomer] = useState({ CustomerId: "", NoOfMembers: "", Name: "", Address: "", Phone: "", Email: "", alternet_phone: "", company_name: "", company_Phone: "", company_Address: "", company_id: "", cnic: "" })
    const url = process.env.REACT_APP_APIURL + "Booking/GetALLBookings?companyid=" + props.companyid;
    const [addunit, setunit] = useState([])
    const [addbtype, setbtype] = useState([])
    const [addshift, setshift] = useState([])
    const [agentuser, setagentuser] = useState([])
    const [agentuservalue, setagentuservalue] = useState([])
    const [bookingdatenew, setbookingdatenew] = useState([])
    const [unitvalue, setunitvalue] = useState()
    const [btypevalue, setbtypevalue] = useState()
    const [shiftvalue, setshiftvalue] = useState()
    const [typevalue, settypevalue] = useState()
    const [typevaluenew, settypevaluenew] = useState()
    const [oldvalue, setoldvalue] = useState({ old: 0 })
    const [oldvaluesf, setoldvaluesf] = useState({ oldsf: 0 })
    const [sto, setsto] = useState()
    const [sfro, setsfro] = useState()
    const [isCheckedmon, setIsCheckedmon] = useState(false);
    const [isCheckedtue, setIsCheckedtue] = useState(false);
    const [isCheckedwed, setIsCheckedwes] = useState(false);
    const [isCheckedsch, setIsCheckedsch] = useState(false);
    const [isCheckedfri, setIsCheckedfri] = useState(false);
    const [loading, setLoading] = useState(true);
    const monthOptions = Array.from({ length: 12 }).map((_, index) => ({
        value: index,
        label: getMonthName(index)
    }));
    const [type, settype] = useState([
        { label: "Corporate", value: "1" },
        { label: "Family", value: "2" },
        { label: "Edu. Institute", value: "3" },
        { label: "Friend", value: "5" }

    ])
    const [Mettypevalue, setMettypevalue] = useState()
    const [Mettype, setMettype] = useState([
        { label: "Cash", value: "1" },
        { label: "Bank", value: "2" },


    ])
    const [addMet, setMet] = useState([])
    const [Metvalue, setMetvalue] = useState()
    const [addbook, setbook] = useState([])
    const [bookvalue, setbookvalue] = useState()
    useEffect(() => {

        fetchUnitdata()
        fetchbtypedata()
        fetchShiftdata(1)
        fetchagentdata()
        fetchUserdata()
        // fetchAgentdata()
    }, [])

const setMettypevalues = (e) => {
    debugger;

    Unitamountss(e.value)


}
async function fetchUserdata() {
    const Uniturl = process.env.REACT_APP_APIURL + "User/GetUsers?companyid=" + props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {

        units.push({ value: u.id, label: u.f_name + " " + u.l_name });
    })
    setbook(units);
}
async function Unitamountss(shiftid) {

    const Uniturl = process.env.REACT_APP_APIURL + "payment/GetMethod?shiftid=" + shiftid + "&companyid=" + props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {
        units.push({ value: u.id, label: u.title });
    })
    setMet(units);

    return ""
}

async function fetchUnitdata() {
    const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {
        units.push({ value: u.unitId, label: u.unitName });
    })
    setunit(units);
}
async function fetchbtypedata() {
    const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetBookingtypes?companyid=" + props.companyid;
    let Unitdata = await axios.get(Uniturl);
    var units = [];
    Unitdata.data.map((u) => {
        units.push({ value: u.id, label: u.val });
    })
    setbtype(units);
}
async function Unitamount(shiftid, unitid, day) {
    debugger;
    const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnitshifts?shiftid=" + shiftid + "&unitid=" + unitid + "&day=" + day + "&companyid=" + props.companyid;
    let res = await axios.get(Uniturl);
    setoldvaluesf({ ...oldvaluesf, oldsf: shiftid })
    setupdateitems({ ...updateitems, Samount: res.data.amount, Damount: res.data.amount })
    setoldvalue({ ...oldvalue, old: res.data.amount })
    return res.data.amount
}
async function fetchShiftdata(unitid) {
    const Uniturl = process.env.REACT_APP_APIURL + "Shift/GetShiftunit?companyid=" + props.companyid + "&unitid=" + unitid;
    let response = await axios.get(Uniturl);
    var data = [];
    response.data.map((u) => {

        data.push({ value: u.shiftId, label: u.shiftName });
    })
    setshift(data);

}
async function fetchagentdata(unitid) {
    const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/agent?companyid=" + props.companyid;
    let response = await axios.get(Uniturl);
    var data = [];
    response.data.map((u) => {
        
        data.push({ value: u.id, label: u.f_name });
    })
    setagentuser(data);
}
const setunitvalues = (e) => {
// fetchShiftdata(e.value)
}
const setbtypevalues = (e) => {
    
}
const setbtypevaluesfilter = (e) => {
    setunitvalue({ value: e.value, label: e.label })
}
const setshiftvaluesfilter = (e) => {
    setshiftvalue({ value: e.value, label: e.label })
}
const setagentuservaluefilter = (e) => {
    debugger;
    setagentuservalue({ value: e.value, label: e.label })
}
const setshiftvalues = (e) => {
    /* debugger; */;
    const date = new Date(updateitems.bookingdate.toString())

    Unitamount(e.value, updateitems.UnitId, date.getDay())

}

const settypevalues = (e) => {
    
    settypevaluenew({ ...typevaluenew, value: e.value, label: e.label })
    if (e.value == 1 || e == 1) {
        $("#Cor").css("display", "flex");
        $("#Cus").css("display", "flex");
    }
    else if (e.value == 2 || e == 2) {
        $("#Cor").css("display", "none");
        $("#Cus").css("display", "flex");
    }
    else if (e.value == 3 || e == 3) {
        $("#Cor").css("display", "none");
        $("#Cus").css("display", "flex");
    }
}
const handleInputCusomter = (e) => {
    
    const name = e.target.name;
    const value = e.target.value;
    setupdateitems({ ...updateitems, [name]: value })
}
const handlePhoneInput = (e) => {
    const { name, value } = e.target;
    const formattedValue = formatPhoneNumber(value);
    setupdateitems({ ...updateitems, [name]: formattedValue });
};
const handletextChange = (event) => {
    debugger;
    const name = event.target.name;
    const value = event.target.value;
    setupdateitems({ ...updateitems, [name]: value, Damount: updateitems.Samount - value, Samount: oldvalue.old, Amount: oldvalue.old, Beforediscount: oldvalue.old })
    //setitems({ ...items, Samount: oldvalue.old })
    //setitems({ ...items, Amount: oldvalue.old })
    //setitems({ ...items, Beforediscount: oldvalue.old })
    //setitems({ ...items, Damount: items.Samount - value })
};
const handleInputBooking = (e) => {
    /* debugger; */;
    const name = e.target.name;
    const value = e.target.value;

    if (name == "per") {
        if (e.target.checked) {

            setupdateitems({ ...updateitems, [name]: value })
            setIsCheckedper(true);
        }
        else {
            setupdateitems({ ...updateitems, [name]: "" })
            setIsCheckedper(false);
        }

    }
    else if (name == "trans") {
        if (e.target.checked) {

            setupdateitems({ ...updateitems, [name]: value })
            setIsCheckedtrans(true);
        }
        else {
            setupdateitems({ ...updateitems, [name]: "" })
            setIsCheckedtrans(false);
        }
    }
    else if (name == "food") {
        if (e.target.checked) {

            setupdateitems({ ...updateitems, [name]: value })
            setIsCheckedfood(true);
        }
        else {
            setupdateitems({ ...updateitems, [name]: "" })
            setIsCheckedfood(false);
        }
    }
    else if (name == "croc") {
        if (e.target.checked) {

            setupdateitems({ ...updateitems, [name]: value })
            setIsCheckedcroc(true);
        }
        else {
            setupdateitems({ ...updateitems, [name]: "" })
            setIsCheckedcroc(false);
        }
    }
    else {
        setupdateitems({ ...updateitems, [name]: value })
    }

}

const handleInputApply = (e) => {
    /* debugger; */;
    setupdateitems({ ...updateitems, Samount: oldvalue.old })
    setupdateitems({ ...updateitems, Amount: oldvalue.old })
    setupdateitems({ ...updateitems, Beforediscount: oldvalue.old })
    if (updateitems.per == "per") {
        var dis = updateitems.Samount * (updateitems.discount / 100);
        setupdateitems({ ...updateitems, Damount: updateitems.Samount - dis })
    }
    else {
        setupdateitems({ ...updateitems, Damount: updateitems.Samount - updateitems.discount })
    }

}
const bookingset = (e) => {
}



// Fetching API data
async function populatedata() {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setitems(result);
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoading(false); 
    }
}
// Function to filter data by selected month
const filterDataByMonth = (monthIndex) => {
    const filtered = items.filter((item) => {
        const itemMonth = new Date(item.bookingdate).getMonth();
        return itemMonth === monthIndex;
    });
    
    setFilteredData(filtered);
};
// Handle month change
const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption ? selectedOption.value : null);
};
// Effect to filter data whenever selectedMonth changes
useEffect(() => {
    if (selectedMonth !== null) {
        filterDataByMonth(selectedMonth);
    }
    destroyDataTable();
}, [selectedMonth, items]);

const destroyDataTable = () => {
    const table = $('#example3').DataTable();
    table.destroy();
};
const initializeDataTable = () => {
    destroyDataTable();
    $('#example3').DataTable({
        "ordering": true,
        "order": []
    });
};
useEffect(() => {
    initializeDataTable();
    // console.log(filteredData);
}, [filteredData]);
// Fetch data on component mount
useEffect(() => {
    populatedata();
}, []);
    
    async function deletedata(id) {
        const urldelete = process.env.REACT_APP_APIURL + 'Booking/DeleteBooking?bookingId=' + id;
        let res = await axios.post(urldelete)
        if (res.status == 200) {
            swal({
                title: "Deleted Successfully",
                icon: "success"
            })
            populatedata();

        }
    }
    async function handleview(id) {
        const url = process.env.REACT_APP_APIURL + "Booking/GetALLBooking?bookingId=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
            if (result.shiftId == 1037) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                setsto("8:00 AM " + newDate);
                setsfro("6:00 PM " + newDate);
            }
            if (result.shiftId == 1038) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 AM " + newDate);
                setsfro("6:00 AM " + newDate1);
            }
            if (result.shiftId == 1039) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 PM " + newDate);
                setsfro("6:00 AM " + newDate1);
            }
            if (result.shiftId == 1040) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 PM " + newDate);
                setsfro("6:00 PM " + newDate1);
            }
            if (result.type == "1") {
                setIsCheckedmon(true);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(false);
                settypevalue("Corporate")
            }
            if (result.type == "2") {
                setIsCheckedmon(false);
                setIsCheckedtue(true);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(false);
                settypevalue("Family")
            }
            if (result.type == "3") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(true);
                setIsCheckedsch(false);
                setIsCheckedfri(false);
                settypevalue("Edu. Institute")
            }
            if (result.type == "4") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(true);
                setIsCheckedfri(false);
                settypevalue("School")
            }
            if (result.type == "5") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(true);
                settypevalue("Friend")
            }
            if (result.status == 404) {
                swal(
                    {
                        icon: 'error',
                        title: 'Not found!',
                    })
            }
            else {
                $("#myModal").modal('show');
                setbookingdetails(result)
                paymentdata(id)
                //console.log(result)
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    async function handleedit(id) {
      
        const url = process.env.REACT_APP_APIURL + "Booking/GetALLBooking?bookingId=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
          
            setupdateitems({ ...updateitems, bookingId: result.bookingId, MethodId: result.metype, Mettype: result.mtype, bookby: result.bookedbyid, UnitId: result.unitId, bookingtype: result.typeid, ShiftId: result.shiftId, AgentId: result.agentId, CustomerId: result.customerId, bookingdate: result.bookingdate.toString().split("T")[0].toString(), Amount: result.amount, note: result.note, Beforediscount: result.beforediscount, type: result.type, userid: result.userid, receipt: result.receipt, Samount: result.samount, Damount: result.damount, per: result.per, trans: result.trans, food: result.food, croc: result.croc, Disnote: result.disnote, adv: result.adv, holdbook: result.holdbook, NoOfMembers: result.noOfMembers, Name: result.cusName, Address: result.address, Phone: result.phone, Email: result.email, alternet_phone: result.alternet_phone, company_name: result.company_name, company_Phone: result.company_Phone, company_Address: result.company_Address, cnic: result.cnic, company_id: props.companyid, discount: result.discount })
            debugger;
            setMettypevalues({ value: result.mtype });
            setshiftvalue({ value: result.shiftId, label: result.shiftName })
            setbtypevalue({ value: result.typeid, label: result.bookingtype})
            setunitvalue({ value: result.unitId, label: result.unitName })
            setbookvalue({ value: result.bookedbyid, label: result.bookedby })
            settypevalues(result.type);
            if (result.mtype == 2) {
                setMettypevalue({ value: result.mtype, label: "Bank" });
            }
            else {
                setMettypevalue({ value: result.mtype, label: "Cash" });
            }
            setMetvalue({ value: result.metype, label: result.title });
            setoldvaluesf({ ...oldvaluesf, oldsf: result.shiftId });
            setoldvalue({ ...oldvalue, old: result.samount })

            if (result.per == "per") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                setIsCheckedper(!isCheckedper);
            }
            else {
                setIsCheckedper(false);
            }
            if (result.food == "food") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                setIsCheckedfood(!isCheckedfood);
            }
            else {
                setIsCheckedfood(false);
            }
            if (result.croc == "croc") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                setIsCheckedcroc(!isCheckedcroc);
            }
            else {
                setIsCheckedcroc(false);
            }
            if (result.trans == "trans") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                setIsCheckedtrans(!isCheckedtrans);
            }
            else {
                setIsCheckedtrans(false);
            }
            if (result.type == "1") {
                settypevaluenew({ ...typevaluenew, value: result.type, label: "Corporate" })
            }
            if (result.type == "2") {
                settypevaluenew({ ...typevaluenew, value: result.type, label: "Family" })
            }
            if (result.type == "3") {
                settypevaluenew({ ...typevaluenew, value: result.type, label: "Student" })
            }
            if (result.status == 404) {
                swal(
                    {
                        icon: 'error',
                        title: 'Not found!',
                    })
            }
            else {
                $("#myModal1").modal('show');
                //setbookingdetails(result)
               // paymentdata(id)
                //console.log(result)
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    const setshiftvaluess = (e) => {

    }
    const [updateitems, setupdateitems] = useState({ bookingId: "", UnitId: "", bookingtype: "", MethodId: "", Mettype: "", ShiftId: "", AgentId: "", CustomerId: "", bookingdate: "", Amount: 0, company_id: "", note: "", Beforediscount: 0, type: "", userid: 0, receipt: "", Samount: 0, Damount: 0, per: "", trans: "", food: "", croc: "", Disnote: "", adv: 0, holdbook: "", NoOfMembers: "", Name: "", Address: "", Phone: "", Email: "", alternet_phone: "", company_name: "", company_Phone: "", company_Address: "", company_id: "", cnic: "" })
    async function handledelete(id) {
        
        swal({
            title: "Are you sure?",
              text: "Once deleted, you will not be able to recover this booking!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                /* debugger; */;
                deletedata(id);

            } else {
                swal("0 Rows Effected");
            }
        });
    }
    async function paymentdata(id) {
        const url = process.env.REACT_APP_APIURL + "payment/GetReceviedAmount?bookingid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
            
            if (result.status == 404) {
                receviedamount.payment = 0
            }
            else {
                setreceviedamount(result);
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    function handleactive(id) {
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                holddata(id);

            } else {
                swal("0 Rows Hold");
            }
        });
    }
    async function holddata(id) {
        //  const urldelete = process.env.REACT_APP_APIURL + 'agent/DeleteAgent?Agentid=' + id;
        /* debugger; */;
        const urldelete = process.env.REACT_APP_APIURL + "Booking/Hold?userid=" + id;
        let res = await axios.post(urldelete);
        /* debugger; */;
        if (res.status == 200) {
            swal({
                title: "Update Successfully",
                icon: "success"
            })
            populatedata();

        }
    }
    const Customersavemethod = async (data) => {
        /* debugger; */;
        return new Promise((resolve, reject) => {
            const url = process.env.REACT_APP_APIURL + "Customer/UpdateCustomer";
            fetch(url, {
                method: "POST",
                headers: {
                    'Accept': "json",
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(async (res) => {
                /* debugger; */;
                if (res.status == 200) {
                    var json = 1;

                    resolve(json);
                }
            }).catch((error) => {
                /* debugger; */;
                reject(error)
            })

        })

    }
    const BookingSaveData = async (booking) => {
        // console.log(booking)
        /* debugger; */;

        const url = process.env.REACT_APP_APIURL + "Booking/UpdateBooking";
        fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(booking)
        }).then(async (res) => {
            if (res.status == 200) {
                /* debugger; */;
                $("#myModal1").modal('hide');
                if (booking.holdbook == "book") {
                    swal({
                        title: "Saved Successfully",
                        icon: "success"
                    })
                }
                else {
                    swal({
                        title: "Reservation Saved Successfully! If you not change the type from hold to book in next 3 days so it will automatically cancel",
                        icon: "success"
                    })
                }

                return true
            }
            else {
                swal({ title: "Failed :(", icon: "error" })
                return false
            }
        }).catch((error) => {
            swal({
                title: "Failed :(",
                text: error,
                icon: "error"
            })
            console.log(error)
        })
    }
    const onChangeDate = e => {
        debugger;
        const newDate = moment(new Date(e.target.value)).format('YYYY-MM-DD');
       
        setitemsfilter({ ...itemsfilter, bookingdate: newDate})

    };
    const handleSubmit1 = async (e) => {
        e.preventDefault();
        debugger;
        if (e.nativeEvent.submitter.id == "book") {
            var date;
            if (itemsfilter.bookingdate != undefined) {
                date = itemsfilter.bookingdate;
            }
            else {
                date = "";
            }
            var shift;
            if (itemsfilter.ShiftId != undefined) {
                shift = itemsfilter.ShiftId;
            }
            else { shift = 0; }

            var unit;
            if (itemsfilter.UnitId != undefined) {
                unit = itemsfilter.UnitId;
            }
            else { unit = 0; }

            var user;
            if (itemsfilter.Agentid != undefined) {
                user = itemsfilter.Agentid;
            }
            else {
                user = 0;}
            const url = process.env.REACT_APP_APIURL + "booking/Getbookingfilter?companyid=" + props.companyid + "&date=" + date + "&shift=" + shift + "&unit=" + unit + "&user=" + user;
            await fetch(url).then(res => res.json()).then(result => {
                debugger;
                $('#example3').DataTable().destroy()
                setitems(result);
            });
        }
        else {

            setunitvalue(null);
            setshiftvalue(null);
            setagentuservalue(null);
            setbookingdatenew(null);
            await fetch(url).then(res => res.json()).then(result => {

                setitems(result);
            });
        }
        
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        /* debugger; */;

        if (updateitems.UnitId === "") {
            swal({
                title: "Unit Required!",
                icon: "error"
            })
            return;
        }
        if (oldvaluesf.oldsf === "") {
            swal({
                title: "Shift Required!",
                icon: "error"
            })
            return;
        }

        var data = {}
        data.UnitId = updateitems.UnitId
        data.typeid = updateitems.bookingtype
        data.ShiftId = updateitems.ShiftId
        data.Amount = updateitems.Damount
        if (updateitems.AgentId) {
            data.AgentId = updateitems.AgentId
        }
        if (e.nativeEvent.submitter.id == "book") {
            data.holdbook = "book"
        }
        else if (e.nativeEvent.submitter.id == "hold") {
            data.holdbook = "hold"
        }
        else {
           
            return false;
        }
        data.bookingdate = updateitems.bookingdate
        data.discount = updateitems.discount
        data.note = updateitems.note
        data.type = updateitems.type
        data.userid = localStorage.getItem("userid")
        data.receipt = updateitems.receipt
        data.Beforediscount = data.Amount
        //if (items.discount.indexOf("%") != -1) {
        //    var dis = data.Amount * (items.discount.replace('%', '') / 100);
        //    data.Beforediscount = data.Amount
        //    data.Amount = data.Amount - dis
        //}
        //else {

        //    var dis = items.discount;
        //    data.Beforediscount = data.Amount
        //    data.Amount = data.Amount - dis
        //}
        debugger;
        data.bookedby = updateitems.bookby
        data.Method_ID = updateitems.MethodId
        data.Samount = updateitems.Samount
        data.Damount = updateitems.Damount
        data.per = updateitems.per
        data.trans = updateitems.trans
        data.food = updateitems.food
        data.croc = updateitems.croc
        data.Disnote = updateitems.Disnote
        data.adv = updateitems.adv
        data.bookingId = updateitems.bookingId
        customer.CustomerId = updateitems.CustomerId
        customer.Address = updateitems.Address
        customer.alternet_phone = updateitems.alternet_phone
        customer.cnic = updateitems.cnic
        customer.company_Address = updateitems.company_Address
        customer.company_name = updateitems.company_name
        customer.company_Phone = updateitems.company_Phone
        customer.Email = updateitems.Email
        customer.Name = updateitems.Name
        customer.NoOfMembers = updateitems.NoOfMembers
        customer.Phone = updateitems.Phone
        fetch(process.env.REACT_APP_APIURL + "Booking/CheckBooking?companyid=" + props.companyid, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(async (res) => {
            /* debugger; */;
            var json = await res.json()
            if (json != 0) {
                customer.company_id = props.companyid
                await Customersavemethod(customer).then((id) => {
                    data.CustomerId = customer.CustomerId
                    data.company_id = props.companyid
                    if (BookingSaveData(data)) {
                      /*  props.savingStatus(true)*/
                    }
                    else {
                       /* props.savingStatus(false)*/
                    }
                   

                }).catch((err) => {
                    /* debugger; */;
                    console.log(err)
                    swal({
                        title: "Failed :(",
                        text: err,
                        icon: "error"
                    })
                })
            }
            else {
                swal({
                    title: ":(",
                    text: " Shift already booked",
                })
                return false
            }
        })
    };

    const dwn = (e) => {
        e.preventDefault();
        let printEleme = document.getElementById('elementPrint');
        var opt = {
            padding:[0,0,3,0],
            filename:`Advance-Receipt_${bookingdetails.bookingId}`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                scale: 2,
                bottom: 20,
                
            },
            pagebreak: { mode: ['css'] },
            jsPDF: {
                unit: 'mm',
                orientation: 'portrait'
            }
        };
        setTimeout(() => {
            html2pdf().set(opt).from(printEleme).then(function () {
            $("#inner").css({ "font-size": "12px", "background-color": "#F5F5F5" });
            }).save();
        }, 300);
      }
      const gatePass = () => {
        let printEleme = document.getElementById('gatePas');
        var opt = {
            padding:[0,0,3,0],
            filename:`Gatepass_${bookingdetails.bookingId}`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                scale: 2,
                bottom: 20,
                
            },
            pagebreak: { mode: ['css'] },
            jsPDF: {
                unit: 'mm',
                orientation: 'portrait'
            }
        };
        setTimeout(() => {
            html2pdf().set(opt).from(printEleme).then(function () {
            $("#inner").css({ "font-size": "12px", "background-color": "#F5F5F5" });
            }).save();
        }, 300);
      }
    /* modal fadeout */
    const modelOut1 = (e) => {
        e.preventDefault();
        $("#myModal").modal('hide');
    }
    /* inline styling */
const card = {
marginBottom: '1.875rem',
backgroundColor: '#fff',
transition: 'all 0.5s ease-in-out',
position: 'relative',
border: '0rem solid transparent',
borderRadius: '1.375rem',
boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
height: 'calc(100% - 1.875rem)',
}
const card_body={
    padding: '0.5rem 2rem 0rem',
    flex: '1 1 auto',
}
const card_header = {
    borderColor: '#ffffff',
    position: 'relative',
    background: '#1d3641',
    padding: '1.5rem 1.875rem 1.25rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#002a73',
    borderRadius: '0 !important',
    backgroundColor: '#fff',
    paddingBottom: '0',
    flexDirection:'column',
    alignItems:'center',
    marginBottom: '1.2rem',
}
const card_logo = {
display: 'flex',
alignItems: 'center',
justifyContent: 'center',
}
const img_logo = {
    width:'225px',
    height:'75px',

}
const re_heading ={
    marginTop:'0.5rem',
}
const d_grid={
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    justifyContent:'center',
}
const lineGrid = {
    disply:'flex',
    marginBottom:'0.5rem',
}
const inLIne = {
    disply:'flex',
    paddingRight: '0.6rem',
}
const pdRight = {
    paddingRight:'0.5rem',
}
const uLine = {
    fontWeight:'600',
    borderBottom: '1px solid gray',
    transform: 'translateY(-6px)',
    paddingLeft: '0.3rem',
    fontSize: '0.9rem',
}
const p_right = {
    paddingRight:'0.8rem',
}
const f_child ={
paddingRight:'0.2rem',
fontSize:'0.9rem',
}
const in_checkBox = {
display:'inline-flex',
alignItems:'center',
}
const in_label={
paddingRight: '0.2rem',
margin:'0',
}
const in_checkbox = {
height: '15px',
width: '15px',
}
const center_text = {
textAlign:'center',
}
const fn_size = {
fontSize:'0.8rem',
marginBottom:'0',
}
const flx_main = {
display:'flex',
alignItems:'center',
justifyContent:'space-between',
flexWrap:'wrap',
width:'100%',
}
const col_5={
display:'flex',
flex:"0 0 50%",
maxWidth:"50%",
}
const col_4 ={
flex:'0 0 40%',
maxWidth:'40%',
}
const col_6 = {
flex:'0 0 60%',
maxWidth:'60%',
}
const col_7 = {
flex:'0 0 70%',
maxWidth:'70%',
}
const col_8= {
flex:'0 0 80%',
maxWidth:'80%'
}
const col_3 = {
flex:'0 0 30%',
maxWidth:'30%',
}
const col_33 = {
flex:'0 0 33%',
maxWidth:'33%',
}
const col_2 = {
flex:'0 0 20%',
maxWidth:'20%',
}
const col_1 = {
flex:'0 0 10%',
maxWidth:'10%',
}
const col_9 = {
flex:'0 0 90%',
maxWidth:'90%',
}
const col_10 ={
flex:"0 0 100%",
maxWidth:'100%',
}
const col_65={
flex:'0 0 65%',
maxWidth:'65%',
}
const col_25 ={
flex:'0 0 25%',
maxWidth:'25%',
}
const m_b1={
marginBottom:'1rem',
}
const d_flex= {
display:'flex',
}
const under_line= {
textDecoration:'underline',
}
const ul_list={
marginBottom: '0.4rem',
listStyle: 'auto',
}
const ul_sty={
   paddingLeft:'1.5rem'
}
const mr_top3={
    marginTop:'3rem',
}
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View Booking List</h3>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit1}>
                            <div className='row'>
                        <div className="mb-3 col-md-6 col-lg-3 mx-auto">
                            <label className="form-label">Select Farm</label>
                                <Select name="unit" value={unitvalue} options={addunit} onChange={(e) => { setitemsfilter({ ...itemsfilter, UnitId: e.value }); setbtypevaluesfilter(e); }} />
                        </div>
                        <div className="mb-3 col-md-6 col-lg-3 mx-auto">
                            <label className="form-label">Shift</label>
                                <Select options={addshift} value={shiftvalue} id="shift" onChange={(e) => { setshiftvaluesfilter(e); setitemsfilter({ ...itemsfilter, ShiftId: e.value }) }} />
                        </div>
                        <div className="mb-3 col-md-6 col-lg-3 mx-auto">
                            <label className="form-label">Agent</label>
                            <Select options={agentuser} value={agentuservalue} id="agent" onChange={(e) => { setagentuservaluefilter(e); setitemsfilter({ ...itemsfilter, Agentid: e.value })}} />
                        </div>
                        <div className="mb-3 col-md-6 col-lg-3 mx-auto">
                            <div className="search-inp">
                                <label className="form-label">Date</label>
                                <input type="date" autoComplete="off" className="form-control" value={itemsfilter.bookingdate} id="mdate" onChange={onChangeDate} />
                            </div>
                        </div>
                        </div>
                        <div className="row justify-content-center inner-btn">
                            <div>
                                <button type="submit" className="btn btn-primary" id="book">Filter</button>
                            </div>
                            
                            <div>
                                <button type="submit" className="btn btn-secondary" id="Cancel">Clear</button>
                            </div>

                            </div>
                        </form>
                        <div className="mb-3 col-md-6 col-lg-3 ">
                            <label className="form-label">Select Month</label>
                            <Select 
                                options={monthOptions} 
                                value={monthOptions.find(option => option.value === selectedMonth)}
                                id="month-select"
                                onChange={handleMonthChange}
                            /> 
                        </div>
                    <div className="main_infoTabl">
                        {loading && (
                            <section className='loader_main'>
                            <span className="loader-5"></span>
                            </section>
                            )}
                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Booking ID</th>
                                        <th>Customer Name</th>
                                        <th>Date</th>
                                        <th>Unit</th>
                                        <th>Shift</th>
                                        <th>Entered By</th>
                                        <th>Booked By</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    {filteredData.map(item =>
                                        item.holdbook === "hold" ? (
                                        <tr key={item.bookingId}>
                                                <td>{item.bookingId}</td>
                                                <td>{item.cusName}</td>
                                            <td>{Moment(item.bookingdate).format('DD/MM/yyyy')}</td>
                                            <td>{item.unitName}</td>
                                                <td>{item.shiftName}</td>
                                                <td>{item.bookby}</td>
                                                <td>{item.bookedby}</td>

                                            <td>
                                                    <span className="d-flex">
                                                        <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                            onClick={() => handleedit(item.bookingId)}>
                                                            <i className="fas fa-pencil-alt"></i>
                                                        </button>
                                                        <button href="#" className="btn btn-dark shadow btn-xs sharp me-2"
                                                        onClick={() => handleview(item.bookingId)}>
                                                            <i className="fas fa-info-circle"></i>
                                                    </button>
                                                    <button href="#" className="btn btn-danger shadow btn-xs sharp me-2"
                                                        onClick={() => deletedata(item.bookingId)}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </span>
                                                
                                            </td>
                                            </tr>
                                        ) :
                                            localStorage.getItem("userTypename") === "Admin" ? (
                                                <tr key={item.bookingId}>
                                                    <td>{item.bookingId}</td>
                                                    <td>{item.cusName}</td>
                                                    <td>{Moment(item.bookingdate).format('DD/MM/yyyy')}</td>
                                                    <td>{item.unitName}</td>
                                                    <td>{item.shiftName}</td>
                                                    <td>{item.bookby}</td>
                                                    <td>{item.bookedby}</td>

                                                    <td>
                                                        <span className="d-flex">
                                                            <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                                onClick={() => handleedit(item.bookingId)}>
                                                                <i className="fas fa-pencil-alt"></i>
                                                            </button>
                                                            <button href="#" className="btn btn-dark shadow btn-xs sharp me-2"
                                                                onClick={() => handleview(item.bookingId)}>
                                                                <i className="fas fa-info-circle"></i>
                                                            </button>
                                                            <button href="#" className="btn btn-danger shadow btn-xs sharp me-2"
                                                                onClick={() => handledelete(item.bookingId)}>
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        </span>

                                                    </td>
                                                </tr>
                                            ) :
                                                localStorage.getItem("userTypename") === "Operation" ? (
                                                    <tr key={item.bookingId}>
                                                        <td>{item.bookingId}</td>
                                                        <td>{item.cusName}</td>
                                                        <td>{Moment(item.bookingdate).format('DD/MM/yyyy')}</td>
                                                        <td>{item.unitName}</td>
                                                        <td>{item.shiftName}</td>
                                                        <td>{item.bookby}</td>
                                                        <td>{item.bookedby}</td>
                                                        <td>
                                                            <span className="d-flex">
                                                                <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                                    onClick={() => handleedit(item.bookingId)}>
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button href="#" className="btn btn-dark shadow btn-xs sharp me-2"
                                                                    onClick={() => handleview(item.bookingId)}>
                                                                    <i className="fas fa-info-circle"></i>
                                                                </button>
                                                                <button href="#" className="btn btn-danger shadow btn-xs sharp me-2"
                                                                    onClick={() => handledelete(item.bookingId)}>
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            </span>

                                                        </td>
                                                    </tr>
                                                ) :
                                                localStorage.getItem("userid") == item.userid ? (
                                                <tr key={item.bookingId}>
                                                    <td>{item.bookingId}</td>
                                                    <td>{item.cusName}</td>
                                                    <td>{Moment(item.bookingdate).format('DD/MM/yyyy')}</td>
                                                    <td>{item.unitName}</td>
                                                    <td>{item.shiftName}</td>
                                                    <td>{item.bookby}</td>
                                                    <td>{item.bookedby}</td>
                                                    <td>
                                                        <span className="d-flex">
                                                            <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                                onClick={() => handleedit(item.bookingId)}>
                                                                <i className="fas fa-pencil-alt"></i>
                                                            </button>
                                                            <button href="#" className="btn btn-dark shadow btn-xs sharp me-2"
                                                                onClick={() => handleview(item.bookingId)}>
                                                                <i className="fas fa-info-circle"></i>
                                                            </button>
                                                            <button href="#" className="btn btn-danger shadow btn-xs sharp me-2"
                                                                onClick={() => handledelete(item.bookingId)}>
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        </span>
                                                    </td>
                                                </tr>
                                                ) :
                                                    <tr key={item.bookingId}>
                                                        <td>{item.bookingId}</td>
                                                        <td>{item.cusName}</td>
                                                        <td>{Moment(item.bookingdate).format('DD/MM/yyyy')}</td>
                                                        <td>{item.unitName}</td>
                                                        <td>{item.shiftName}</td>
                                                        <td>{item.bookby}</td>
                                                        <td>{item.bookedby}</td>
                                                        <td>
                                                            <span className="d-flex">
                                                                <button href="#" className="btn btn-dark shadow btn-xs sharp me-2"
                                                                    onClick={() => handleview(item.bookingId)}>
                                                                    <i className="fas fa-info-circle"></i>
                                                                </button>
                                                            </span>
                                                        </td>
                                                    </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg"> 
                    <div className="modal-content" >
                        {/* card start */}
                                                <div className='card' id="elementPrint">
                                                    <div className='card-header d-flex flex-column' >
                                                        <div style={card_logo}>
                                                          <img style={img_logo} src={Royal_logo} alt="Royal-Logo" />
                                                        </div>

                                                        <h3 style={re_heading}>Advance Receipt</h3>
                                                        <div className='download_button' id='repoPrint' data-html2canvas-ignore="true"><a onClick={dwn} href="">Download</a><a onClick={modelOut1} href="">✕</a></div>
                                                    </div>
                                                    <div className='card-body'>
                                                        <div style={d_grid}>
                                                            <div style={lineGrid}>
                                                                <span style={inLIne}><span style={f_child}>Srl#</span><span style={uLine}>{"S" + bookingdetails.bookingId}</span></span>
                                                           </div>
                                                            <div style={lineGrid} className='input-grup'>
                                                                <span style={inLIne}><span style={f_child}>Booking Date:</span><span style={uLine}>{Moment(bookingdetails.bookingdate).format('DD/MM/yyyy')}</span></span>
                                                             <span style={inLIne}><span style={f_child}>Farm#</span><span style={uLine}>{bookingdetails.unitName}</span></span>
                                                            <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="company">Company</label><input style={in_checkbox} type="checkbox" id='company' checked={isCheckedmon} readOnly/></span></span>
                                                            <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="family">Family</label><input style={in_checkbox} type="checkbox" id='family' checked={isCheckedtue}  readOnly/></span></span>
                                                                <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="Edu. Institute">Edu. Institute</label><input style={in_checkbox} type="checkbox" id='Edu. Institute' checked={isCheckedwed} readOnly /></span></span>
                                                                <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="Friend">Friend</label><input style={in_checkbox} type="checkbox" id='Friend' checked={isCheckedfri} readOnly /></span></span>
                                                           </div>
                                                           <div style={{...lineGrid, ...center_text, ...flx_main }}>
                                                                <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm3 tm-md-1' style={{ ...f_child, ...col_5 }}>TImeSlot:(Day & Time)</span><span style={{ ...uLine, ...col_5 }}>{sto}</span></span>
                                                                <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm2-3 tm-md-2' style={{ ...f_child, ...col_4 }}>To(Day & Time)</span><span style={{ ...uLine, ...col_6 }}>{sfro}</span></span>
                                                             <span style={col_10}><strong><p style={fn_size}>(22H Booking: Morning 8am to 6am or Night 8pm to 6pm next day & for 10H: Morning 8am to 6pm or Night 8pm to 6am)</p></strong> </span>
                                                           </div>
                                                           <div style={{...lineGrid, ...flx_main }}>
                                                                <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm4-3 gm-md-1' style={{ ...f_child, ...col_65 }}>No. of "Guests Allowed" (Max.)</span><span style={{ ...uLine, ...col_2 }}>{bookingdetails.noOfMembers}</span></span>
                                                                <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm1-8 ev-md-2' style={{ ...f_child, ...col_3 }}>Event Type:</span><span style={{ ...uLine, ...col_7 }}>{typevalue}</span></span>
                                                           </div>
                                                           <div style={{...lineGrid, ...flx_main }}>
                                                             <span className='main-col-item m-b-1' style={{...inLIne, ...col_5}}><span className='colsm2 cl-md-1' style={{...f_child,...col_3}}>Client Name:</span><span style={{...uLine,...col_7}}>{bookingdetails.cusName}</span></span>
                                                             <span className='main-col-item m-b-1' style={{...inLIne, ...col_5}}><span style={{...f_child,...col_1}}>Cell</span><span style={{...uLine,...col_9}}>{bookingdetails.phone ? bookingdetails.phone.replace(/(\d{4})(\d{7})/, '$1 $2') : 'N/A'}</span></span>
                                                           </div>
                                                           <div style={{...lineGrid, ...flx_main }}>
                                                             <span className='main-col-item m-b-1' style={{...inLIne, ...col_5}}><span className='colsm2-5 tlt-md-1' style={{...f_child,...col_4}}>Total Amount:Rs. </span><span style={{...uLine,...col_4}}>{bookingdetails.amount}</span></span>
                                                             <span className='main-col-item m-b-1' style={{...inLIne, ...col_5}}><span className='colsm4-3 paid-md-2' style={{...f_child,...col_6}}>Amount Paid (Advance): Rs.</span><span style={{...uLine,...col_4}}>{receviedamount.payment}</span></span>
                                                             <span style={{...col_10,...m_b1 }}><strong><p style={fn_size}></p></strong> </span>
                                                           </div>
                                                           <div style={{...lineGrid, ...flx_main }}>
                                                             <span className='main-col-item m-b-1 ful-width' style={{...inLIne, ...col_6, ...d_flex}}><span className='colsm3 bl-md-1' style={{...f_child,...col_4}}>Balance Amount: Rs.</span><span style={{...uLine,...col_4}}>{(isNaN(bookingdetails.amount) ? 0 : bookingdetails.amount) - (isNaN(receviedamount.payment) ? 0 : receviedamount.payment)}</span></span>
                                                           </div>
                                                            <div style={{ ...lineGrid, ...flx_main }}>
                                                                <span className='main-col-item m-b-1 ful-width' style={{ ...inLIne, ...col_10, ...d_flex }}><span className='colsm3-5 adi-md-1' style={{ ...f_child, ...col_25 }}>Additional Instructions:</span><span className='colsm6-5' style={{ ...uLine, ...col_7 }}>{bookingdetails.note}</span></span>
                                                            </div>
                                                            <div className='mb-3 contact-farm'><strong>Farm Contact No. 0301-0881116</strong></div>
                                                        </div>
                                                        {/* important notes */}
                                <div>
                                    <h5>IMPORTANT NOTES:</h5>
                                    <ul className='list-Style' style={ul_sty}>
                                        <li style={ul_list}>Read carefully the attached "Booking Contract & Rules Regulations".</li>
                                        <li style={ul_list}>Full payment is required to be paid at least before 48 hours(2 days) of the program/party for issuance of "Gate Pass". <span className='underline' >No one is allowed to enter in Resort / Farmhouse without "Gate Pass". </span></li>
                                        <li style={ul_list}>Please inform us at least one week prior to the event, in case of any changes or cancellation of event, Your amount can be adjusted to new available date. In case of less than one week you deposited amount will be forfeited.</li>
                                        <li style={ul_list}> Couples are not allowed without “Nikah Nama” or Proof of Relationship.</li>
                                        <li style={ul_list}> Use of drinks (alcohol), dance party, any indecent gathering/activity, Loud Music, any kind of weapon, Fireworks, Shisha (Hukkah), Laser Lights, spitting, drone camera, Paan/Gutka, and any illegal activity etc. are strictly not allowed.</li>
                                        <li style={ul_list}>Maximum "Guest Allowed" would be followed strictly; else you will be required to pay 1000 per person at the farmhouse entery.</li>
                                        <li style={ul_list}> Resort coupons can be utilized as per scheduled timings that is 5am to 7am or 4pm to 6pm.</li>
                                        <li style={ul_list}> Sports Activities and other electrical appliances may be suspended due to weather or any other unforeseen reasons at any time.</li>
                                    </ul>
                                </div>
                                {/* footer signnature */}
                                <div className='html2pdf__page-break'>
                                <div style={{...d_grid, ...mr_top3}}>
                                   <div style={{...lineGrid, ...flx_main }}>
                                            <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_4, ...d_flex }}><span className='bk-md-1' style={{ ...f_child, ...col_3 }}>Booked By:</span><span style={{ ...uLine, ...col_6 }}>{bookingdetails.bookedby}</span></span>
                                     <span className='main-col-item m-b-1' style={{...inLIne, ...col_5, ...d_flex}}><span style={{...f_child,...7}}>Date of issuing Receipt</span><span style={{...uLine,...col_3}}>{Moment(bookingdetails.entrydate).format('DD/MM/yyyy')}</span></span>
                                     <span style={{...col_10,...m_b1 }}><strong><p style={fn_size}></p></strong> </span>
                                   </div>
                                </div>
                                </div>
                                <div className='my_updatepdf'>
                                 <img src={Notice} alt="notice_PDf" />
                                </div>
                            </div>
                    </div>
                        {/* card end */}
                {/* gat pass card */}
                        
             {/* gat pass card */}
                    </div>
                </div>
            </div>
            <div id="myModal1" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-5 mt-5 text-center mx-auto">Update Booking</h3>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row flex-column align-items-center">
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Date</label>
                                                <input type="date" autoComplete="off" className="form-control" value={updateitems.bookingdate} id="mdate" onChange={(e) => { setitemsnew({ ...itemsnew, bookingdate: e.target.value }) }} disabled />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="unit_name" className="form-label">Unit</label>
                                                <Select name="unit" value={unitvalue} options={addunit} onChange={(e) => { setunitvalue(e); setupdateitems({ ...updateitems, UnitId: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="unit-label">Shift</label>
                                                <Select options={addshift} value={shiftvalue} id="shift" onChange={(e) => { setshiftvalues(e); setupdateitems({ ...updateitems, ShiftId: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Amount</label>
                                                <input type="text" autoComplete="off" id="Amount" name="note" value={updateitems.Samount} onChange={handleInputBooking} className="form-control" readOnly />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Discount</label>
                                                <input type="text" autoComplete="off" name="discount" value={updateitems.discount} onChange={handletextChange} className="form-control" />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12" hidden>
                                                <label htmlFor="timepicker2">Discount Type Apply</label>
                                                {/* <Select value={daystypevalue} options={daystype} onChange={(e) => { setdaystypevalue(e); setitems({ ...items, daystype: e.value }) }} />*/}
                                                <div className="checkbox-group" id="checkboxes">
                                                    <ul>
                                                        <li>
                                                            <input type="checkbox" id="per" name="per" value="per" onChange={handleInputBooking} checked={isCheckedper}/>
                                                            <label htmlFor="per">%</label>

                                                        </li>
                                                        <li>
                                                            <button type="button" className="btn btn-success btn-xs" onClick={handleInputApply}>Apply</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Discounted Price</label>
                                                <input type="text" autoComplete="off" name="Damount" value={updateitems.Damount} onChange={handleInputBooking} className="form-control" readOnly />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Discount Justify</label>
                                                <input type="text" autoComplete="off" name="Disnote" value={updateitems.Disnote} onChange={handleInputBooking} className="form-control" />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Advance Payment</label>
                                                <input type="text" autoComplete="off" name="adv" value={updateitems.adv} onChange={handleInputBooking} className="form-control" />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="booking_id" className="form-label">Method</label>
                                                <Select value={Mettypevalue} options={Mettype} onChange={(e) => { setMettypevalues(e); setitems({ ...items, Mettype: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Title</label>
                                                <Select options={addMet} value={Metvalue} id="title" onChange={(e) => { setshiftvaluess(e); setupdateitems({ ...updateitems, MethodId: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="bookingtype" className="form-label">Booking Type</label>
                                                <Select name="bookingtype" value={btypevalue} options={addbtype} onChange={(e) => { setbtypevalue(e); setupdateitems({ ...updateitems, bookingtype: e.value }) }} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="bookedby" className="form-label">Booked By</label>
                                                <Select name="bookedby" value={bookvalue} options={addbook} onChange={(e) => { setbookvalue(e); setupdateitems({ ...updateitems, bookby: e.value }) }} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="timepicker2">Event Type</label>
                                                <Select value={typevaluenew} options={type} onChange={(e) => { settypevalues(e); setupdateitems({ ...updateitems, type: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12" hidden>
                                                <label htmlFor="timepicker2">Other Services</label>
                                                {/* <Select value={daystypevalue} options={daystype} onChange={(e) => { setdaystypevalue(e); setitems({ ...items, daystype: e.value }) }} />*/}
                                                <div className="checkbox-group" id="checkboxes">
                                                    <ul>
                                                        <li>
                                                            <input type="checkbox" id="trans" name="trans" value="trans" onChange={handleInputBooking} checked={isCheckedtrans} />
                                                            <label htmlFor="trans"><i className="fa fa-subway"></i></label>

                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="food" name="food" value="food" onChange={handleInputBooking} checked={isCheckedfood}/>
                                                            <label htmlFor="food"><i className='fas fa-pizza-slice'></i></label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="croc" name="croc" value="croc" onChange={handleInputBooking} checked={isCheckedcroc}/>
                                                            <label htmlFor="croc"><i className="fas fa-utensils"></i></label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>



                                            <div id="Cus" className="row" style={{ display: "none" }}>
                                                <div className="mb-3 col-sm-12 col-lg-12">
                                                    <label className="form-label">Customer name</label>
                                                    <input type="text" autoComplete="off" name="Name" value={updateitems.Name} onChange={handleInputCusomter} className="form-control" required />
                                                </div>
                                                <div className="mb-3 col-sm-12 col-lg-12">
                                                    <label className="form-label">No of members</label>
                                                    <input type="number" autoComplete="off" name="NoOfMembers" value={updateitems.NoOfMembers} onChange={handleInputCusomter} className="form-control" required />
                                                </div>

                                                <div className="mb-3 col-sm-12 col-lg-12">
                                                    <label className="form-label">Primary Phone</label>
                                                    <input type="text" autoComplete="off" name="Phone" value={updateitems.Phone ? updateitems.Phone.replace(/(\d{4})(\d{7})/, '$1 $2') : 'N/A'} onChange={handlePhoneInput} className="form-control" maxLength="12" placeholder="XXXX XXXXXXX" required />
                                                </div>
                                                <div className="mb-3 col-sm-12 col-lg-12">
                                                    <label className="form-label">CNIC</label>
                                                    <input type="text" autoComplete="off" name="cnic" value={updateitems.cnic} onChange={(e) => setupdateitems({ ...updateitems, cnic: e.target.value.replace(/\D/g, "") })} className="form-control" maxLength="13" placeholder="Enter 13-digit CNIC" required />
                                                </div>
                                                <div className="mb-3 col-sm-12 col-lg-12" hidden>
                                                    <label className="form-label">Address</label>
                                                    <input type="text" autoComplete="off" name="Address" value={updateitems.Address} onChange={handleInputCusomter} className="form-control" />
                                                </div>

                                            </div>


                                            <div id="Cor" className="row" style={{ display: "none" }}>
                                                <div className="mb-3 col-sm-12 col-lg-12">
                                                    <label className="form-label">Company Name</label>
                                                    <input type="text" autoComplete="off" name="company_name" value={updateitems.company_name} onChange={handleInputCusomter} className="form-control" />
                                                </div>
                                                <div className="mb-3 col-sm-12 col-lg-12">
                                                    <label className="form-label">Company Phone</label>
                                                    <input type="text" autoComplete="off" name="company_Phone" value={updateitems.company_Phone ? updateitems.company_Phone.replace(/(\d{4})(\d{7})/, '$1 $2') : ''} onChange={handlePhoneInput} className="form-control" maxLength="12" placeholder="XXXX XXXXXXX" />
                                                </div>
                                                <div className="mb-3 col-sm-12 col-lg-12">
                                                    <label className="form-label">Company Address</label>
                                                    <input type="text" autoComplete="off" name="company_Address" value={updateitems.company_Address} onChange={handleInputCusomter} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Special Notes</label>
                                                <input type="text" autoComplete="off" name="note" value={updateitems.note} onChange={handleInputBooking} className="form-control" />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12" hidden>
                                                <label className="form-label">receipt</label>
                                                <input type="text" autoComplete="off" name="receipt" value={updateitems.receipt} onChange={handleInputBooking} className="form-control" />
                                            </div>
                                           


                                            <br />
                                            <br />
                                            <br />
                                           
                                        </div>
                                        <div className="row justify-content-center inner-btn">
                                            <div>
                                                <button type="submit" className="btn btn-primary" id="book">Book</button>
                                            </div>
                                            {/*<div>*/}
                                            {/*    <button type="submit" className="btn btn-warning" id="hold">Hold</button>*/}
                                            {/*</div>*/}
                                            {/*<div>*/}
                                            {/*    <button type="submit" className="btn btn-secondary" id="Cancel">Cancel</button>*/}
                                            {/*</div>*/}

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ViewBooking;